import React from 'react';
import { useApp } from '../../context/AppContext';
import { Mode } from '../../types';
import './ModeToggle.css';

const MODES: { id: Mode; es: string; en: string }[] = [
  { id: 'ejecutivo', es: 'Ejecutivo', en: 'Executive' },
  { id: 'consejero', es: 'Consejero CdA', en: 'Board Director' },
  { id: 'conferenciante', es: 'Conferenciante', en: 'Speaker' },
];

const ModeToggle: React.FC = () => {
  const { mode, setMode, lang } = useApp();

  return (
    <div className="mode-toggle" role="group" aria-label="CV mode">
      {MODES.map(m => (
        <button
          key={m.id}
          className={`mode-toggle__btn ${mode === m.id ? 'active' : ''}`}
          onClick={() => setMode(m.id)}
        >
          {m[lang]}
        </button>
      ))}
    </div>
  );
};

export default ModeToggle;
